import React from "react";
import {Grid, TextField} from "@mui/material";
import {Controller} from "react-hook-form";
import ErrorMessage from "components/form/ErrorMessage";
import Label from "../../Label";

export default function TextInput({
                                      control,
                                      name,
                                      label,
                                      gridProps,
                                      require,
                                      answerId,
                                      ...props
                                  }) {
    return (
        <Grid item xs={12} {...gridProps}>
            <Label require={require}>{label}</Label>
            <Controller
                control={control}
                name={name}
                render={({field, fieldState: {error}}) => {
                    return (
                        <TextField
                            {...field}
                            ref={field.ref}
                            value={(field.value||[])[0]?.text}
                            onChange={(event)=>{
                                field.onChange([{answerId,text:event.target.value}])
                            }}
                            error={error?.message}
                            multiline
                            minRows={3}
                            helperText={<ErrorMessage message={error?.message}/>}
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            size="small"
                            FormHelperTextProps={{variant: "standard"}}
                            {...props}
                        />
                    );
                }}
            />
        </Grid>
    );
}
